import { render, staticRenderFns } from "./ModelTwoNewExecution.vue?vue&type=template&id=34980de2&scoped=true&"
import script from "./ModelTwoNewExecution.vue?vue&type=script&lang=js&"
export * from "./ModelTwoNewExecution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34980de2",
  null
  
)

export default component.exports